import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { BenefitHospitalNetworkAction } from '../APIs/action';
import NetworkHospitalCard from './NetworkHospitalCard';
import SearchIcon from '@mui/icons-material/Search';
import { TextField } from '../../../MUI_custom_component';

const NetworkHospitalPage = () => {
  const [loader, setLoader] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [hospitalListMap, setHospitalListMap] = useState({});
  const [selectedState, setSelectedState] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const BenefitHospitalNetwork = async () => {
    setLoader(true);
    const { data, message, error } = await BenefitHospitalNetworkAction();
    setLoader(false);
    if (!error) {
      setAllStates(data.state_list || []);
      setHospitalListMap(data.hospital_state_wise_map || {});
      setSelectedState(data.state_list?.[0] || '');
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    BenefitHospitalNetwork();
  }, []);

  useEffect(() => {
    setSearchTerm('');
  }, [selectedState]);

  const filteredHospitals =
    hospitalListMap[selectedState]?.filter((hospital) =>
      hospital?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
    ) || [];

  if (loader) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Typography
        variant='h2'
        sx={{ mb: 1 }}
      >
        Cashless Network Hospitals
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{ alignItems: 'center' }}
      >
        <Grid
          item
          xs={12}
          sm={6}
        >
          <Typography
            variant='body2'
            sx={{
              fontSize: '13px',
              mb: 1,
              color: '#636363',
              fontWeight: 'bold',
            }}
          >
            State
          </Typography>
          <FormControl
            fullWidth
            sx={{ mb: 1 }}
          >
            <Select
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
              size='small'
            >
              {allStates?.map((state) => (
                <MenuItem
                  key={state}
                  value={state}
                >
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <Box sx={{ height: { xs: 0, sm: '14px' } }} />

          <TextField
            placeholder='Search Hospitals'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
      </Grid>

      <Typography
        variant='h3'
        sx={{ mb: 2 }}
      >
        {filteredHospitals.length} Hospitals found.
      </Typography>
      {selectedState &&
        filteredHospitals.map((hospital, idx) => (
          <NetworkHospitalCard
            key={hospital?.id || idx}
            hospital={hospital}
            idx={idx}
          />
        ))}
    </Box>
  );
};

export default NetworkHospitalPage;
